<svelte:head>
  <!-- Primary Meta Tags -->
  <title>D-NS Studio | {details.instructor} | {videoInfo.about}</title>
  <meta name="title" content="D-NS Studio | {details.instructor} | {videoInfo.about}">
  <meta name="description" content={videoInfo.description}>

	<!-- FB Tags -->
	<meta property="og:url" content="https://d-ns.studio/session/{id}">
  <meta property="og:title" content="D-NS Studio | {details.instructor} | {videoInfo.about}">
  <meta property="og:description" content={videoInfo.description}>

	<!-- Twitter Tags -->
	<meta property="twitter:url" content="https://d-ns.studio/session/{id}">
  <meta property="twitter:title" content="D-NS Studio | {details.instructor} | {videoInfo.about}">
  <meta property="twitter:description" content={videoInfo.description}>
</svelte:head>

<style src="./style.scss">

</style>

<div mbsc-accordion class="mbsc-form-details mbsc-col-12 mbsc-col-lg-8">
  <div class="mbsc-form-group" data-collapsible data-open>
    <div class="mbsc-form-group-title">
      <div class="mbsc-row">
        <div class="mbsc-row-12 mbsc-col-sm-8">
          <h2>{name} | D-NS Sessions #{id}</h2>
          {#if videoInfo && videoInfo.about}<p>{@html videoInfo.about}...</p>{/if}
        </div>
        <div class="mbsc-row-12 mbsc-col-sm-4 mbsc-align-center">
          <iframe title="sharebox" src="{FbIframeSrc}" width="59" height="65" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
        </div>
      </div>
    </div>
    {#if details}
    <div class="mbsc-form-group-content">
      <div class="mbsc-row">
        <div class="mbsc-col-12 mbsc-col-md-6">
        {#if details.instructor}<p><strong>Instructor:&nbsp;</strong>{@html details.instructor}</p>{/if}
        {#if details.disciplina}<p><strong>Disciplina:&nbsp;</strong>{@html details.disciplina}</p>{/if}
        {#if details.studio}<p><strong>Studio:&nbsp;</strong>{@html details.studio}</p>{/if}
        {#if details.email}<p><strong>Correo electrónico:&nbsp;</strong>{@html details.email}</p>{/if}
        {#if details.whatsapp}<p><strong>Whatsapp:&nbsp;</strong><a target="_blank" href="https://wa.me/{details.whatsapp}">Contáctame</a>{/if}
        {#if details.fb}<p><strong>Facebook:&nbsp;</strong><a target="_blank" href="http://m.me/{details.fb}">Contáctame</a>{/if}
        {#if details.tw}<p><strong>Twitter:&nbsp;</strong><a target="_blank" href="{details.tw}">Sígueme</a>{/if}
        {#if details.in}<p><strong>Instagram:&nbsp;</strong><a target="_blank" href="{details.in}">Sígueme</a>{/if}
        {#if details.yt}<p><strong>Youtube:&nbsp;</strong><a target="_blank" href="{details.yt}">Sígueme</a>{/if}
        {#if videoInfo && videoInfo.soundtrack}<p><strong>Música:&nbsp;</strong>{@html videoInfo.soundtrack}</p>{/if}
        </div>
        <div class="mbsc-col-12 mbsc-col-md-6">
        {#if videoInfo && videoInfo.equipment}<p><strong>Equipo necesario:&nbsp;</strong>{@html videoInfo.equipment}</p>{/if}
        {#if videoInfo && videoInfo.recommended}<p><strong>Sugerencias:&nbsp;</strong>{@html videoInfo.recommended}</p>{/if}
        {#if videoInfo && videoInfo.description}<p><strong>Descripción:&nbsp;</strong>{@html videoInfo.description}</p>{/if}
        {#if videoInfo && videoInfo.tools}<p><strong>Uso de herramientas:&nbsp;</strong>{@html videoInfo.tools}</p>{/if}
        {#if videoInfo && videoInfo.relatesTo}<p><strong>Disciplinas Relacionadas:&nbsp;</strong>{@html videoInfo.relatesTo}</p>{/if}
        {#if videoInfo && videoInfo.audience}<p><strong>Recomendado para:&nbsp;</strong>{@html videoInfo.audience}</p>{/if}
        {#if videoInfo && videoInfo.rate}<p><strong>Clasificación:&nbsp;</strong>{@html videoInfo.rate}</p>{/if}
        </div>
      </div>
    </div>
    {/if}
  </div>
</div>

<script>
  import { onMount, afterUpdate } from 'svelte';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  export let name = 'RAO';
  export let id = '001';
  const FbIframeSrc = 'https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fd-ns.studio%2F%23%2Fsession%2F' + id + '&width=59&layout=box_count&action=like&size=small&share=true&height=65&appId=2613568418969987';
  export let details = null;
  export let videoInfo = null;
  export let hideContent = false;

  afterUpdate(() => {
    if (hideContent) {
      var collapsibles = document.querySelector('[data-collapsible]');
      mobiscroll.instances[collapsibles.id].hide();
    }
  });

  onMount(async () =>{
    mobiscroll.settings = {
      theme: 'd-ns',
      themeVariant: 'light',
      lang: 'es'
    };

    mobiscroll.form('.video-details', {});
    mobiscroll.form('.mbsc-form-details', {
      theme: 'd-ns'
    });

    mobiscroll.card('video-details-card', {
      theme: 'd-ns'
    });
  });
</script>
